import React from "react";

const UpdateExpense = () => {
  return <div>update expense</div>;
};

export default UpdateExpense;